/**
 *
 * PfAlert
 *
 */

import React from 'react';
import Pficon from 'components/Pficon';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import {
  TYPE_DANGER,
  TYPE_SUCCESS,
  TYPE_SUGGESTION,
  TYPE_SUGGESTION_DARK,
  TYPE_WARNING,
  TYPE_WARNING_SOFT,
  TYPE_MAINTENANCE,
  TYPE_SOLUTION,
} from './constants';

const types = {
  [TYPE_DANGER]: {
    icon: 'danger',
    color: 'color-red-6',
  },
  [TYPE_SUCCESS]: {
    icon: 'success',
    color: 'color-green-6',
  },
  [TYPE_SUGGESTION]: {
    icon: 'star_negative',
    color: 'color-purple-6',
  },
  [TYPE_SUGGESTION_DARK]: {
    icon: 'star_negative',
    color: 'color-grey-10',
  },
  [TYPE_WARNING]: {
    icon: 'warning-boxed',
    color: 'color-yellow-6',
  },
  [TYPE_WARNING_SOFT]: {
    icon: 'warning-boxed',
    color: 'color-purple-6',
  },
  [TYPE_MAINTENANCE]: {
    icon: 'wrench-boxed',
    color: 'color-yellow-6',
  },
  [TYPE_SOLUTION]: {
    icon: 'thumb_up',
    color: 'color-blue-6',
  },
};

function PfAlert({
  title,
  description,
  type,
  noBackground = false,
  noPadding = false,
  iconSize = 'small',
  className = '',
  centerIcon = false,
  inlineStyle = true,
  skipIcon = false,
}) {
  let colorClass = '';
  let iconType = '';
  // NOTE: the icon is overflowing its parent for some reason, and flex-start was not working as expected
  // vertical-alignment worked best
  const fontSize = iconSize === 'small' ? 10 : 12;
  const margin = 5;
  const iconDisplay = centerIcon
    ? 'flex flex-align-items--center'
    : 'display-inline-block';

  if (types[type]) {
    colorClass = types[type].color;
    iconType = types[type].icon;
  } else {
    throw new Error('Wrong type provided!');
  }

  return (
    <div
      className={classnames(
        className,
        'text-size-secondary',
        'border-radius-level-1',
        'display-flex',
        {
          'padding-right-lg': !noPadding,
          'padding-vertical-xxs': !noPadding,
          'background-grey-3': !noBackground,
          'padding-left-xxs': !noBackground,
        },
        colorClass,
      )}
    >
      {!skipIcon && (
        <Pficon
          type={iconType}
          className={`margin-right-xxs position-relative ${iconDisplay}`}
          style={{ fontSize, marginTop: 2 }}
        />
      )}
      <div
        className="display-inline-block vertical-align-top"
        style={
          inlineStyle
            ? { width: `calc(100% - ${fontSize + margin}px)` }
            : undefined
        }
      >
        {title && <span className="text-weight-bold">{title}</span>}
        {description && <div>{description}</div>}
      </div>
    </div>
  );
}

PfAlert.propTypes = {
  title: PropTypes.any,
  description: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  type: PropTypes.string.isRequired,
  iconSize: PropTypes.string,
  noBackground: PropTypes.bool,
  noPadding: PropTypes.bool,
  className: PropTypes.string,
  centerIcon: PropTypes.bool,
  inlineStyle: PropTypes.bool,
  skipIcon: PropTypes.bool,
};

export default PfAlert;
